<!-- Alert.vue -->
<template>
  <material-alert
    class="text-center"
    :value="!!message"
    type="success"
    dismissible
    border="left"
    @input="closeAlert"
  >
    {{ message }}
  </material-alert>
</template>

<script>
  // Utilities
  import { call, get } from 'vuex-pathify'

  export default {
    name: 'Alert',
    computed: {
      message: get('alert/message'),
    },
    methods: {
      setAlert: call('alert/setAlert'),
      closeAlert () {
        this.setAlert({})
      },
    },
  }
</script>
